export default {
  methods: {
    format (num) { //千分位转换
      var reg=/\d{1,3}(?=(\d{3})+$)/g;   
      return (num + '').replace(reg, '$&,');  
    },
    render_price(data,value) {
      // console.log(data);
      if(data.priceSectionDataVo) {
        data.priceSectionDataVo.forEach(v=>{  //销量千分位转换
          if(v.proCountAndSaleNum) {
            // v.saleNum = this.format(v.saleNum)
            v.proCountAndSaleNum.forEach(k=>{
              k.saleNum = this.format(k.saleNum)
            })
          }
        })
      }
      let text = ''
      if (value) {
        text = '月均销售过百的产品价格段分布'
      }else {
        text = '全品类价格段分布'
      }
      let xAxisData = data.priceSectionDataVo ?  data.priceSectionDataVo.filter(v=>v.productCount).map(v=>v.priceSection) : []
      let option = {
        // title: {
        //   text: text,
        //   top: 10
        // },
          // subtitle: {
          //     text: `截止到${new Date().getMonth + 1}月，上新数${data.newProductTotal}}共计销量${data.saleNumTotal}`,
          //     top: 0,
          //     right: 0,
          //     textStyle: {
          //       fontSize: 12,
          //       color: '#777',
          //       fontWeight: 'normal'
          //     }
          // },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              },
              enterable: true,
              hideDelay: 300,
              formatter: params => {
                let work = data.priceSectionDataVo.filter(v=>v.productCount)
                const arr = work[params[0].dataIndex].proCountAndSaleNum;
                let str = "";
                str = `${work[params[0].dataIndex].priceSection}价格段<br/>`
                arr.forEach(item=>{
                  str += `${item.categoryName}上新${item.newProductCount||0}种销量${item.saleNum||0}<br/>`
                })
                // let all = `${data.priceSectionDataVo[params[0].dataIndex].priceSection}总销量${data.priceSectionDataVo[params[0].dataIndex].saleNum}<br/>`
                // str += all
                // return `<div style="height: 300px; overflow: scroll;"><div class="infinity-scroll">${str}</div></div>`
                return str
              },
              // position: [10, 10],
              // alwaysShowContent: true,
              // className: 'tooltips-scroll',
              // triggerOn: 'click'
          },
          legend: {
              data: ['销量', '产品数'],
              top: 50,
              textStyle: {
                color: '#fff',
                fontFamily: 'PingFangSC'
              }
          },
          grid: {
            left: 70,
            bottom: 30,
            right: 50,
            top: 120
          },
          dataZoom: {
            type: 'inside',
            start: 0,
            end: xAxisData.length<(window.innerWidth == 1920 ? 12 : 7) ? 100 : ((window.innerWidth == 1920 ? 11 : 6)/xAxisData.length)*100
          },
          xAxis: [
              {
                  type: 'category',
                  data: xAxisData,
                  axisPointer: {
                    type: 'shadow',
                    label: {
                      show: false
                    }
                  },
                  axisTick: { show: false },
                  // axisLabel: {
                  //   color: 'rgb(135,139,160)',
                  //   interval: 0,
                  //   formatter: value =>{
                  //     if(value.length > 4) {
                  //       return String(value).substring(0,4)+'...'
                  //     }else{
                  //       return value+'月'
                  //     }
                  //   }
                  // },
                  axisLine: {
                    lineStyle: {
                      color: 'rgba(255,255,255,0.9)'
                    }
                  }
              }
          ],
          yAxis: [
            {    
              name: '销量',
              type: 'value',
              axisPointer: {
                type: 'line',
                label: {
                  color: '#000',
                  backgroundColor: '#fff',
                }
              },
              minInterval: 1,
              axisTick: { show: false },
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#e2e2e2',
                  opacity: 0.5,
                  width: 0,
                  fontFamily: 'PingFangSC',
                }
              },
              splitLine: { show: false }
          },
          {
              name: '产品数',
              type: 'value',
              axisPointer: {
                type: 'line',
                label: {
                  color: '#000',
                  backgroundColor: '#fff',
                }
              },
              minInterval: 1,
              axisTick: { show: false },
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#e2e2e2',
                  opacity: 0.5,
                  width: 0,
                  fontFamily: 'PingFangSC',
                }
              },
              splitLine: { show: false }
          }
          ],
          series: [
              {   
                  name: '销量',
                  type: 'line',
                  yAxisIndex: 0,
                  data:  data.priceSectionDataVo ? data.priceSectionDataVo.filter(v=>v.productCount).map(v=>v.saleNum) : [],
                  itemStyle: {
                    color: 'rgb(250,137,0)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  // showBackground: true,
                  label: {
                    show: true,
                    position: 'right',
                    color: '#e2e2e2',
                    fontFamily: 'PingFangSC'
                  },
                  select: {
                    label: {
                      show: true
                    },
                    itemStyle: {
                      color: '#ffffff',
                      borderColor: '#00A6ED',
                      borderWidth: 0
                    }
                  },
                  selectedMode: true
              },
              {
                  name: '产品数',
                  type: 'bar',
                  yAxisIndex: 1,
                  data: data.priceSectionDataVo ? data.priceSectionDataVo.filter(v=>v.productCount).map(v=>v.productCount) : [],
                  itemStyle: {
                    color: 'rgb(11,183,142)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  // showBackground: true,
                  label: {
                    show: true,
                    position: 'top',
                    color: '#e2e2e2',
                    fontFamily: 'PingFangSC'
                  },
                  select: {
                    label: {
                      show: true
                    },
                    itemStyle: {
                      color: '#00A6ED',
                      borderColor: '#00A6ED'
                    }
                  },
                  selectedMode: true
              }
          ],
          animationDelay: function(idx) {
            return 50*idx
          }
      };
      let $instance = this.$echarts.init(this.$refs['price']);
      $instance.setOption(option);
      // $instance.on('click',params => {
      //     console.log(params);
      //     this.$refs['classify'].handleCategoryChange(params.name)
      //     $instance.dispatchAction({
      //       type: 'select',
      //       seriesIndex: params.seriesIndex ? 0 : 1,
      //       dataIndex: params.dataIndex
      //     });
      // });
    }
  }
}